
import Vuex from 'vuex'




export const store =  new Vuex.Store({
	state: {
		rightView: 'user-quote-list',
		prop1: '',
		prop2: '',
		prop3: [],

		quotesData: [],
		quotesDataComp: '0',

	},

	mutations: {
		setRightView(state, payload) { state.rightView = payload.name; state.prop1 = payload.prop1; state.prop2 = payload.prop2; state.prop3 = payload.prop3},

		setUserQuotes(state, payload) { state.quotesData = payload.info; state.quotesDataComp = payload.info1; },
		setUserQuotesComp(state, payload) { state.quotesDataComp = payload.info1; },

		
  	},

	actions: {
		getRightView(context, payload) { context.commit("setRightView", { name: payload.name, prop1: payload.prop1, prop2: payload.prop2, prop3: payload.prop3 })  },
	
		getAllUserQuotes(context, payload) {
			context.commit("setUserQuotesComp", { info1: '0' }) 
			axios.get('/utility/user/quote/getuserquotes')
	          	.then(function (response) {
	          		var a = response.data.data;
					if(a == null || a == ''){ var b = []; } else { var b = a; }
			        context.commit("setUserQuotes", { info: b, info1: '1' }) 
	          	});
		},
		
		
		
	}

})